import _isNil from 'lodash/isNil'
import _isObject from 'lodash/isObject'

import {
  multiCaseGet,
  multiCaseHas,
  objectToSnakeCase,
  getSnakeCaseKey,
} from '@/lib/json/case'

const FILE_KEYS = ['file', 'image', 'logo', 'avatar', 'heroImage']

function isFileKey(key: string): boolean {
  return FILE_KEYS.includes(key)
}

function hasFile(data: Any): boolean {
  if (_isObject(data)) {
    return FILE_KEYS.some(key => multiCaseHas(data, key))
  }
  return false
}

export function createHeaders(data: Any): Record<string, string> {
  if (hasFile(data)) {
    return { 'Content-Type': 'multipart/form-data' }
  }
  return {}
}

export function createPayload(data: Any): Any {
  if (_isObject(data) && hasFile(data)) {
    const formData = new FormData()
    const payloadKeys = Object.keys(data)

    payloadKeys.forEach(payloadKey => {
      if (isFileKey(payloadKey)) {
        const file = multiCaseGet(data, payloadKey)
        if (file) {
          formData.append(getSnakeCaseKey(payloadKey), file)
        }
      } else {
        // Handle non-file fields - convert to snake_case
        const snakeCaseObj = objectToSnakeCase({
          [payloadKey]: (data as Record<string, Any>)[payloadKey],
        })
        const entries = Object.entries(snakeCaseObj)
        if (entries.length > 0) {
          const [convertedKey, convertedValue] = entries[0]
          formData.append(convertedKey, convertedValue as Any)
        }
      }
    })

    return formData
  }

  let payload = data
  if (_isObject(payload)) {
    payload = objectToSnakeCase(data)
  }
  return payload
}

export function constructQueryParams(params: Record<string, Any>): string {
  if (_isObject(params)) {
    const cleanedParamKeys = Object.keys(params).filter(key => !_isNil(params[key]))

    return cleanedParamKeys.reduce((paramsString, paramKey, index) => {
      const encodedParam = encodeURIComponent(params[paramKey])
      const nextParam = `${paramKey}=${encodedParam}`
      return index === cleanedParamKeys.length - 1
        ? `${paramsString}${nextParam}`
        : `${paramsString}${nextParam}&`
    }, '')
  }

  return ''
}
